import frankPic from "@/public/images/artists/frank.png";
import { Artist } from "@/types/types";

export const frank = {
  id: "289",
  name: "Frank",
  image: frankPic,
  description: `Frank has warm, understated voice with a soft tone, light texture, and laid-back delivery.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ffrank-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Unprocessed",
        "Airy",
        "Falsetto",
        "RnB",
        "Indie",
        "Alternative",
        "Pop",
        "Dance",
        "Soul",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 70,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
